import { useMemo } from "react";

import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

export default function useAvailableLicensesCount() {
  const { licenses } = useSelectedWorkspaceContext();

  const availableLicensesCount = useMemo(
    () => licenses.filter(({ account_id }) => !account_id).length,
    [licenses],
  );

  return { availableLicensesCount };
}
